import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#000000"
}
function SkiMak026({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M129 33.25q-2.05-4.7-5.05-8.45-9.5-12.6-24.65-13.7 1-3.05-.4-6-1.4-3-3.45-5.1.2 1.5.1 2.95-.6 5.45-3.4 7.55-.9.55-3.6 1.2-2.65.6-3.1.7l-.3.1q-1.1.4-1.65.55-1.3.35-2.5.8-1.05.35-2 .8-4.45 1.8-7.4 4.5-1.1.95-2 2-2.1 2.9-3 6.45-.9-3.55-3-6.45-.9-1.05-2-2-2.95-2.7-7.4-4.5-.95-.45-2-.8-1.2-.45-2.5-.8-.55-.15-1.65-.55l-.3-.1q-.45-.1-3.1-.7-2.7-.65-3.6-1.2-2.8-2.1-3.4-7.55-.1-1.45.1-2.95-2.05 2.1-3.45 5.1-1.4 2.95-.4 6-15.15 1.1-24.65 13.7-3 3.75-5.05 8.45-8.4 16.65 0 30.1 1.8 2.9 4.4 5.3 3 2.3 6.9 4.1 1.45.55 3 1.1-.4 3.95-1.4 5.75-.7 1.3-1.7 2.5 2.7-.85 4.1-1.8 3.9-2.45 5.7-4.6 2.8.6 5.95 1.1 12.8.95 21.95-4.05 6.45-4.15 11.1-11.7.6-.85 1.75-2.35.1-.25.25-.45.2-.35.4-.65.2.35.4.65.15.2.25.45 1.15 1.5 1.75 2.35 4.65 7.55 11.1 11.7 9.15 5 21.95 4.05 3.15-.5 5.95-1.1 1.8 2.15 5.7 4.6 1.4.95 4.1 1.8-1-1.2-1.7-2.5-1-1.8-1.4-5.75 1.55-.55 3-1.1 3.9-1.8 6.9-4.1 2.6-2.4 4.4-5.3 8.4-13.45 0-30.1z"
                    id="SkiMak026__Symbol_33_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#SkiMak026__Symbol_33_0_Layer0_0_FILL"
                transform="translate(125.9 119.65)"
                id="SkiMak026__col1n"
            />
        </g></g>
    )
}
export default SkiMak026
